import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { LOGO_SEAL, NAV_ITEMS, CONTACT_PLACEHOLDERS } from "@/lib/constants";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-brand-forest text-white"
    >
      <div className="absolute inset-0 bg-topo opacity-20 pointer-events-none" aria-hidden="true" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-10 lg:px-12 pt-20 pb-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          {/* Seal & mission */}
          <div className="lg:col-span-5">
            <div className="flex items-start gap-6">
              <img
                src={LOGO_SEAL}
                alt="Hawaii Housing Foundation Seal"
                className="w-28 h-28 md:w-32 md:h-32 object-contain shrink-0 drop-shadow-lg"
                data-testid="footer-seal-img"
              />
              <div>
                <p className="eyebrow text-brand-gold">Hawaii Housing Foundation</p>
                <h3 className="font-heading text-2xl md:text-3xl text-white mt-3 leading-tight">
                  To keep Hawaii home.
                </h3>
                <p className="mt-4 text-white/70 text-sm leading-relaxed max-w-md">
                  Solutions for today. Stability for tomorrow.
                </p>
              </div>
            </div>
          </div>

          {/* Explore */}
          <div className="lg:col-span-3">
            <p className="eyebrow text-brand-gold mb-6">Explore</p>
            <ul className="space-y-3">
              {NAV_ITEMS.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    data-testid={`footer-link-${item.label.toLowerCase()}`}
                    className="text-white/80 hover:text-brand-gold transition-colors text-sm"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="lg:col-span-4">
            <p className="eyebrow text-brand-gold mb-6">Contact</p>
            <ul className="space-y-4 text-sm text-white/80">
              <li className="flex items-start gap-3" data-testid="footer-address">
                <MapPin size={16} className="mt-0.5 text-brand-gold shrink-0" />
                <span>{CONTACT_PLACEHOLDERS.address}</span>
              </li>
              <li className="flex items-start gap-3" data-testid="footer-phone">
                <Phone size={16} className="mt-0.5 text-brand-gold shrink-0" />
                <a href={`tel:${CONTACT_PLACEHOLDERS.phone}`} className="hover:text-brand-gold transition-colors">
                  {CONTACT_PLACEHOLDERS.phone}
                </a>
              </li>
              <li className="flex items-start gap-3" data-testid="footer-email">
                <Mail size={16} className="mt-0.5 text-brand-gold shrink-0" />
                <a href={`mailto:${CONTACT_PLACEHOLDERS.email}`} className="hover:text-brand-gold transition-colors break-all">
                  {CONTACT_PLACEHOLDERS.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/50 tracking-wider uppercase" data-testid="footer-copyright">
            © {year} Hawaii Housing Foundation. All rights reserved.
          </p>
          <p className="text-xs text-white/40 italic font-heading">
            Solutions for today. Stability for tomorrow.
          </p>
        </div>
      </div>
    </footer>
  );
}
